import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const footerLinks = [
    {
      title: 'Privacy',
      path: 'https://www.pmi.org/privacy',
    },
    {
      title: 'Sitemap',
      path: 'https://www.pmi.org/sitemap-page',
    },
    {
      title: 'Terms of use',
      path: 'https://www.pmi.org/terms',
    },
    {
      title: 'Purchasing Terms',
      path: 'https://www.pmi.org/about/purchasing-terms-and-conditions',
    },
    {
      title: 'Advertising & Sponsorship',
      path: 'https://www.pmi.org/about/advertising-sponsorship',
    },
  ];

  // noinspection JSValidateTypes
  return (
    <footer className="page-footer">
      <div className="footer-row">
        <div className="row">
          <div className="col-md-6 col-sm-12 text-start">
            <ul className="list-unstyled d-flex  mt-2 pmi-adp-legal-links">
              {footerLinks.map(({ title, path }, i) => (
                <li
                  key={`footer-link-${i.toString()}`}
                  className="d-inline-block"
                  title={title}
                  data-testid="Link-footerLinks"
                >
                  <a href={path} className="text-muted text-decoration-none">
                    {title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-md-6 col-sm-12 text-end">
            <p
              className="text-muted text-xl-end text-lg-end text-md-end text-sm-center pt-3 pmi-adp-footer__copyright"
              data-testid="Text-copyright"
            >
              &copy; {currentYear} Project Management Institute, Inc.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
